import { Action, createAction, props } from '@ngrx/store';

/**
 * Tipos de Acción para el Store de Permisos
 */
export enum PermisosActionTypes {
    AsignaPermisos = '[Permisos] Asigna Permisos',
    AsignaBreadcrumb = '[Permisos] Adigna Breadcrumb',
    EliminaPermisos = '[Permisos] Elimina Permisos',
}

export const AsignaPermisos = createAction(PermisosActionTypes.AsignaPermisos, props<{ modulos: any }>());
export const AsignaBreadcrumb = createAction(PermisosActionTypes.AsignaBreadcrumb, props<{ breadcrumb: any }>());
export const EliminaPermisos = createAction(PermisosActionTypes.EliminaPermisos);

